import React from "react";
import {ChipLabel} from "./index";

const FamilyOfficeChip = ({type}) => {
    const typeData = {
        "other": {
            class: "status-chip create",
            text: "Other"
        },
        "single family office": {
            class: "status-chip primary",
            text: "SFO"
        },
        "multi family office": {
            class: "status-chip secondary",
            text: "MFO"
        },
        "no family office": {
            class: "status-chip none",
            text: "None"
        },
    }

    return (<ChipLabel label={typeData[type]?.text} className={typeData[type]?.class}/>)
}

export default FamilyOfficeChip;
